import {
  InvitationTemplate,
  IUserAlternativeTemplate,
} from "@/types/event-template-alternative-user";
import { LanguageCode } from "@/types/language";
import { BaseService } from "./BaseService";

class AlternativeUserService extends BaseService<IUserAlternativeTemplate> {
  constructor() {
    super("/api/event-template-alternative-users");
  }

  async updatePreferredLanguage(
    userId: string,
    preferredLanguage: LanguageCode,
  ): Promise<IUserAlternativeTemplate> {
    return this.patch(`${userId}/preferred-language`, {
      preferredLanguage: preferredLanguage,
    } as Partial<IUserAlternativeTemplate>);
  }

  async updateMessages(
    userId: string,
    data: {
      invitationMessage: {
        ch: string;
        en: string;
        kh: string;
      };
      seoMessage:
        | {
            ch: { title: string; description: string } | null;
            en: { title: string; description: string } | null;
            kh: { title: string; description: string } | null;
          }
        | Record<
            LanguageCode,
            { title: string; description: string } | null
          >
        | null;
    },
  ): Promise<IUserAlternativeTemplate> {
    return this.patch(`${userId}/messages`, data as any);
  }

  async updateThankYouMessage(
    existingUser: IUserAlternativeTemplate,
  ): Promise<IUserAlternativeTemplate> {
    return this.create(existingUser);
  }

  async updateInvitationTemplates(
    existingUser: IUserAlternativeTemplate,
    invitationTemplates: InvitationTemplate[],
  ): Promise<IUserAlternativeTemplate> {
    const payload = {
      ...existingUser,
      invitationTemplates,
    };
    return this.create(payload as any);
  }
}

export const alternativeUserService = new AlternativeUserService();

